
import { ref ,inject} from 'vue' 
import { GetPayFn } from "@/hooks/index";
import router from "@/router";
export default {
//import引入的组件需要注入到对象中才能使用
props:{
  payInfo:{  //订单信息
            type: Object,
            required: true,
        },  //弹窗falg
        isShowPayPop:{
            type: Boolean,
            default:false
        }
},
components: {},
setup(props:any,{ emit }: any) {
    const $http: any = inject("$http");
    const store: any = inject("$store");
    const loading = ref(false);
    
  let pay_way = ref('1')
   const payBtnFn = () => {
     loading.value = true
      if (pay_way.value == "1") {
      emit('closePopupFn',false)
        // router.push(
        //   `/mpesa?phone=${props.payInfo.receiver.phone}&pay_sn=${props.payInfo.pay_sn}`
        // );
        emit('m_pesa_showFn',true)
      } else {
        GetPayFn($http, props.payInfo.pay_sn);
      }
      setTimeout(() => {
      loading.value = false
      },1200)
    };
    const closeFn = () => {
      emit('closePopupFn',false)
    }
    return {
      pay_way,
      closeFn,
      payBtnFn,
      store,
      loading
    }
}
}
